export const createSubscription = `
    mutation createSubscription($input: CreateSubscriptionInput!) {
        createSubscription(input:$input) {
            id
            customerId
            customer {
                id
                name
            }
            created
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updated  
    }
}`;

export const updateSubscription = `
    mutation updateSubscription($input: UpdateSubscriptionInput!) {
        updateSubscription(input:$input){
            id
            customerId
            customer {
                id
                name
            }
            created
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updated       
            updatedByUsername
        }
}`;

export const deleteSubscription = `
    mutation deleteSubscription($input: DeleteSubscriptionInput!) {
        deleteSubscription(input:$input) 
}`;
